// extracted by mini-css-extract-plugin
export default {"imageBox":"ContactUs_imageBox__nHghD","img":"ContactUs_img__kPbzY","avatar":"ContactUs_avatar__j95CK","editButton":"ContactUs_editButton__7UOTq"};